<template>
  <div
    class="changelog-details"
  >
    <div
      v-if="!showingRelatedActions"
      class="changelog-details__header"
    >
      <a @click="hideDetails()">
        <i class="fa fa-arrow-left" />&nbsp; <span
          v-t="'Back'"
          class="back-label"
        />
      </a>
    
      <span
        class="changelog-details__date"
        v-text="dateTime"
      />
    </div>

    <h2
      v-if="!showingRelatedActions"
      class="white m-b-20"
      v-html="statement"
    />

    <div v-if="changelog.action !== 'Archive'">
      <legend
        class="p-l-0 m-b-5"
      >
        <span v-t="'Changes'" />
      </legend>

      <ChangeLogDelta
        v-if="changelog && showChangeLogDetails"
        :delta="changelog.diff"
        :wide="wide"
      />
    </div>

    <div class="m-t-10">
      <div
        v-for="relatedAction in changelogRelatedActions" 
        :key="relatedAction.transactionId"
        class="changelog-entry-list-item changelog-entry-list-item__related"
      >
        <div
          @click="showChangelogDetails(relatedAction)"
        >
          <ChangeLogEntry
            :changelog="relatedAction"
          />
        </div>
        
        <ChangeLogDetails
          v-if="relatedAction.transactionId == currentRelactedActionOpen"
          :changelog="relatedAction"
          :showing-related-actions="true"
          :wide="wide"
        />
      </div>
    </div>
  </div>
</template>

<script>
import messages from './locales';
import ChangeLogEntry from './ChangeLogEntry';
import ChangeLogDelta from './ChangeLogDelta';
import moment from 'moment';

import { getActionStatement } from './changelog-helpers';

export default {
  name: 'ChangeLogDetails',

  components: {
    ChangeLogEntry,
    ChangeLogDelta
  },

  props:{
    changelog: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    },
    changelogRelatedActions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    wide: {
      type: Boolean,
      default: false
    },
    showingRelatedActions: {
      type: Boolean,
      default: false
    },
    showChangeLogDetails: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentRelactedActionOpen: null,
      showChanges: false
    };
  },
  computed: {
    statement() {  
      return getActionStatement(this.changelog);
    },
    dateTime() {
      return moment(String(this.changelog.dtStamp)).format('MMM d, YYYY h:mmA');
    }
  },
  methods: {
    hideDetails() {
      this.$emit('toggle-details', null);
    },
    showChangelogDetails(log) {
      if (log.action !== 'Create') {
        this.currentRelactedActionOpen = log.transactionId; 
      }
    }
  },
  i18n: {
    messages,
    locale: 'en',
  }
};
</script>
